import React from "react";
import "./index.css";

export function InputLoadingSkeleton(){
  return (
    <div className="input-section-skeleton skeleton-animation"></div>
  )
}
